import Home from "../pages/Home";
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Semafix from "../Semafix/Components/Semafix_Landing_Page";
import Onde from "../pages/Onde";
import MysteryClient from "../pages/MysteryClient";
import ClientInterface from "../pages/ClientInterface";
import PageNotFound from "../pages/PageNotFound";
import GestionUser from "../Admin/AdminPages/GestionUser";
import AdminDasboard from "../Admin/AdminPages/AdminDasboard";
import Betwin from "../pages/Betwin";
import Lavagna from "../pages/Lavagna";
import TraffixAllInOne from "../pages/TraffixAllInOne";
import SignalFix from "../pages/SignalFix";
import SimFix from "../pages/SimFix";
import Analysis from "../pages/Analysis";
import DataClient from "../Admin/AdminPages/DataClient";
import { Upload } from "antd";
import UploadSimFix from "../Admin/AdminPages/UploadSimFix";
import Tools from "../Admin/AdminPages/Tools";
import MysteryClientUploadData from "../Admin/AdminPages/MysteryClientUploadData";
import RichiediDemo from "../Admin/AdminPages/RichiediDemo";
import Settings from "../pages/Settings";
import AIWayport from "../pages/AIWayport";
function Router({ isAuthenticated, isAdmin, user }) {
  return (
    <Routes>
      {/* Public route for the Login Page */}
      <Route
        path="/auth"
        element={
          isAuthenticated ? <Navigate to="/" replace /> : <MysteryClient />
        }
      />
      {/* Protected routes */}
      <Route
        path="/"
        element={isAuthenticated ? <Home /> : <Navigate to="/auth" replace />}
      />
      <Route
        path="/versions"
        element={
          isAuthenticated && isAdmin ? (
            <DataClient />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/admin/upload_simFix"
        element={
          isAuthenticated && isAdmin ? (
            <UploadSimFix />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/admin/richiedi_demo"
        element={
          isAuthenticated && isAdmin ? (
            <RichiediDemo />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/admin/tools"
        element={
          isAuthenticated && isAdmin ? (
            <Tools />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/admin/mystery_client_management"
        element={
          isAuthenticated && isAdmin ? (
            <MysteryClientUploadData />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/admin/user_management"
        element={
          isAuthenticated && isAdmin ? (
            <GestionUser />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/admin/dashboard"
        element={
          isAuthenticated && isAdmin ? (
            <AdminDasboard />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/admin/data_upload"
        element={
          isAuthenticated && isAdmin ? (
            <DataClient />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/semafix"
        element={
          isAuthenticated &&
          (user.permissions.includes("semafix") || user.is_admin) ? (
            <Semafix />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/onde_verde"
        element={
          isAuthenticated &&
          (user.permissions.includes("onde_verde") || user.is_admin) ? (
            <Onde />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/betwin"
        element={
          isAuthenticated &&
          (user.permissions.includes("betwin") || user.is_admin) ? (
            <Betwin />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
            <Route
        path="/Lavagna"
        element={
          isAuthenticated &&
          (user.permissions.includes("Lavagna") || user.is_admin) ? (
            <Lavagna />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/traffix_all_in_one"
        element={
          isAuthenticated &&
          (user.permissions.includes("traffix_all_in_one") || user.is_admin) ? (
            <TraffixAllInOne />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/AIWayport"
        element={
          isAuthenticated &&
          (user.permissions.includes("AIWayport") || user.is_admin) ? (
            <AIWayport />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
        <Route
        path="/analysis"
        element={
          isAuthenticated &&
          (user.permissions.includes("analysis") || user.is_admin) ? (
            <Analysis />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/signal_fix"
        element={
          isAuthenticated &&
          (user.permissions.includes("signal_fix") || user.is_admin) ? (
            <SignalFix />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/mystery_client"
        element={
          isAuthenticated &&
          (user.permissions.includes("mystery_client") || user.is_admin) ? (
            <ClientInterface />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/ClientInterface"
        element={
          isAuthenticated &&
          (user.permissions.includes("ClientInterface") || user.is_admin) ? (
            <ClientInterface />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      <Route
        path="/sim_fix/confronto"
        element={
          isAuthenticated &&
          (user.permissions.includes("sim_fix") || user.is_admin) ? (
            <SimFix />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />

      <Route
        path="/settings"
        element={
          isAuthenticated ? (
            <Settings user={user} />
          ) : (
            <Navigate to="/auth" replace />
          )
        }
      />
      {/* 404 Page */}
      <Route path="/404" element={<PageNotFound />} />

      {/* Catch all other routes */}
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}

export default Router;
